module.exports = __webpack_public_path__ + "img/etang_verdure(2).2152b63d.jpg";